import React from 'react';
import cookie from 'react-cookies';
import { Loader } from 'oxyrion-ui/lib';
import i18n from 'i18next';
import { initReactI18next, I18nextProvider } from 'react-i18next';
import styled from 'styled-components';
import API2 from '../API2';
import { actions } from '../Store';
import { parseHash } from '../Utils';
import cookieConfig from '../ContentConfig/cookie';
import AclList from '../ACL';
import ApiCustom from '../APICustom';

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 29% 0;
`;

API2.setBaseUrl(process.env.REACT_APP_DOMAIN_2);
ApiCustom.setBaseUrl(process.env.REACT_APP_DOMAIN_2);

API2.onResponseUnauthorized = () => {
  window.location.href = '/';
  this.removeCookie();
};

const backRedirect = process.env.REACT_APP_CALLBACK_REDIRECT;

const authorize = Component => {
  return class Auth extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        isLoading: false,
        authorized: false,
      };
    }

    async componentDidMount() {
      const query = parseHash(window.location.hash);
      if (query.error) {
        window.location.href = `${backRedirect}/${window.location.hash}`;
      }
      if (query.token && query.token !== '') {
        this.removeCookie();
        this.setCookie(query.token, query.expires_at, query.expires_in);
      }
      const accessToken = this.getCookie();
      if (accessToken && accessToken !== 'null') {
        this.login(accessToken);
      } else {
        window.location.href = `${backRedirect}/${window.location.hash}`;
        this.setState({ isLoading: false, authorized: false });
      }
    }

    setCookie(token, expirationDate = Date.now() + 3600, maxAge = 3600) {
      cookie.save(cookieConfig.name, token, {
        path: '/',
        expires: new Date(expirationDate),
        maxAge,
      });
    }

    getCookie() {
      return cookie.load(cookieConfig.name);
    }

    removeCookie() {
      cookie.remove(cookieConfig.name, {
        path: '/',
      });
    }

    async login(token) {
      try {
        this.setState({ isLoading: true });
        API2.setToken(token);
        ApiCustom.setToken(token);

        const user = await API2.b2bMeAction();
        const settings = await API2.getB2BMeSettingsAction();

        actions.setSettings(settings.b2b_settings);
        actions.setUser(user);
        actions.setMenuState(localStorage.getItem('menuState') === 'true');

        const activeCart = localStorage.getItem('activeCart');

        actions.setActiveCart(
          activeCart &&
            activeCart.length > 10 &&
            user.my_carts.find(m => m._id === activeCart)
            ? activeCart
            : user.my_carts[0] && user.my_carts[0]._id,
        );

        actions.setCarts(
          user.my_carts && user.my_carts.length ? user.my_carts : [],
        );
        actions.setYear(
          Number(cookie.load('year')) || new Date().getFullYear(),
        );

        const res = await Promise.all([
          API2.getB2BTranslationsAction({
            app: 'B2B',
          }),
          API2.getB2BLanguagesAction({ app: 'B2B' }),
          API2.getB2BUserMenuItems(),
          API2.getB2BRolesAction(),
        ]);
        const { items: translations } = res[0];
        const { items: langs } = res[1];
        const menuItems = res[2];
        const roles = res[3];

        actions.setMenuItems(menuItems || []);
        actions.setAppLang(user.appLang || user.firm);
        actions.setLangs(langs || []);
        actions.setRoles(roles || []);
        actions.setUserRole(roles.find(r => r._id === user.role));

        const resources = {};

        translations.forEach(t => {
          resources[t.lang] = {
            translation: t.translations,
          };
        });

        i18n
          .use(initReactI18next) // passes i18n down to react-i18next
          .init({
            resources,
            lng: user.appLang || user.firm,
            keySeparator: false, // we do not use keys in form messages.welcome

            interpolation: {
              escapeValue: false, // react already safes from xss
            },
          });

        window.location.hash = '';

        const activeTrans = translations.find(
          t => t.lang === (user.appLang || user.firm),
        );

        actions.setHeader(
          `${
            activeTrans &&
            activeTrans.translations &&
            activeTrans.translations['Príjemný deň']
              ? activeTrans.translations['Príjemný deň']
              : 'Príjemný deň'
          }, ${user.name}  ${
            window.location.hostname.includes('beta') ? '- BETA' : ''
          }`,
        );

        this.setState({ isLoading: false, authorized: true });
      } catch (e) {
        console.log(e);
        window.location.hash = '';
        // window.location.href = `${backRedirect}/${window.location.hash}`;
        this.removeCookie();
      }
    }

    render() {
      if (this.state.isLoading) {
        return (
          <LoaderWrapper>
            <Loader size="xl" />
          </LoaderWrapper>
        );
      }

      if (this.state.authorized) {
        return (
          <I18nextProvider i18n={i18n}>
            <AclList component={Component} />
          </I18nextProvider>
        );
      }
      return (
        <LoaderWrapper>
          <Loader size="xl" />
        </LoaderWrapper>
      );
    }
  };
};

export default authorize;



// WEBPACK FOOTER //
// ./src/Auth/index.js